import { gql } from '@apollo/client'

export default gql(`
    mutation batchUpdateBucketGroupType($contents: [UpdateBucketGroupTypeInput] $project:String) {
        batchUpdateBucketGroupType(input: $contents project: $project) {
            id
        }
    }`
)
